// @ vendors
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const trim = require('lodash/string/trim');
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
// @ constants
const {
    BROKER_CUSTOM_WALLET_CREATE_ACCOUNT_ID,
    BROKER_CUSTOM_WALLET_PG_VIEW,
    BROKER_CUSTOM_WALLET_MAX_ON_CREATE
} = require('../constants/index');
const actionTypes = require('constants/actionTypes');
const notification = require('actions/notifications');
const portfolios = require('./brokerCustomWalletPortfolios');
const { filterPgContracts } = require('../reducers/brokerCustomWalletParseHelper');

// @ utils
const { formatText } = require('core/i18n').i18n;

const init = () => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_PORTFOLIO_INIT,
});

const loadEditablePortfolio = (immWallet) => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_LOAD_PORTFOLIO_BUFFER,
    payload: immWallet
});

const loadEditablePortfolioById = (immWalletId) => (dispatch, getState)=> {
    const immWallet = getState().brokerCustomWalletPortfolios.get('customWallets').find( wallet => {
        return wallet.get('idPortfolioAccount') === immWalletId;
    });
    dispatch(loadEditablePortfolio(immWallet))
};

const validate = () => (dispatch, getState) => {
    const immBrokerCustomWalletPortfolios = getState().brokerCustomWalletPortfolios;

    const currentWallets = immBrokerCustomWalletPortfolios
        .get('customWallets')
        .toJS()
        .map(w => {
            return {
                idPortfolioAccount: w.idPortfolioAccount,
                descriptionPortfolioAccount: trim(w.descriptionPortfolioAccount.toLowerCase())
            }
        });

    dispatch({
        type: actionTypes.BROKER_CUSTOM_WALLET_VALIDATE,
        payload:  { currentWallets }
    });
}

const showValidationError= () => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_SHOW_VALIDATION_ERRORS
})

const inputNameChange = input => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_NAME_CHANGE,
    payload: input
});

const changeSwitchItemContract = contractNumber => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_CONTRACT_ITEM_CHANGE_ENABLED,
    payload: {
        contractNumber,
    }
});

const savePortfolioRequest = () => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_SAVE_REQUEST
});

const savePortfolioError = (error) => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_SAVE_ERROR,
    payload: { error }
});

const confirmedCreateDefaultSuccess = (idDefaultViewToSet) => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_CHANGE_DEFAULT_CONFIRMED_SUCCESS,
    payload: {
        idDefaultViewToSet
    }
});

const outdateMyInvestments = () => (dispatch) => {
    return dispatch({
        type: actionTypes.CW_GET_MY_INVESTMENTS_SET_OUTDATED
    });
};

const setDefaultView = (portfolioAccountId) => (dispatch) => {
    const url = apiURLBuilder.getURL('brokerSetDefaultView');
    const requestData = {
        query : {
            preferences: [
                {
                    name: BROKER_CUSTOM_WALLET_PG_VIEW,
                    value: portfolioAccountId
                }
            ]
        }
    }
    let message;
    return APIPost(dispatch, url, requestData)
        .then(function() {
                message = formatText('brokerCustomWallet-setDefaultViewSuccess');
                dispatch(notification.success({message}, {voice: message}));
                dispatch(confirmedCreateDefaultSuccess(portfolioAccountId));
                dispatch(outdateMyInvestments());
            }, function() {
                message = formatText('brokerCustomWallet-setDefaultViewError');
                dispatch(notification.error({message}, {voice: message}));
            }
        );
};


const savePortfolio = (callbacks) => (dispatch, getState) => {

    dispatch(validate());
    const immBrokerCustomWalletEditablePortfolio =  getState().brokerCustomWalletEditablePortfolio;
    const isValid = immBrokerCustomWalletEditablePortfolio.getIn(['validation','isValid']);

    if (isValid) {
        const requestData = {
            query: {
                accountDescription: immBrokerCustomWalletEditablePortfolio.get('viewName'),
                portfolioAccountId: immBrokerCustomWalletEditablePortfolio.get('idPortfolioAccount') || BROKER_CUSTOM_WALLET_CREATE_ACCOUNT_ID,
                portfolioIds: immBrokerCustomWalletEditablePortfolio.get('contractsJoined')
            }
        };
        const portfolioAccountId = immBrokerCustomWalletEditablePortfolio.get('idPortfolioAccount')
        const newName = immBrokerCustomWalletEditablePortfolio.get('viewName');
        const newContracts = immBrokerCustomWalletEditablePortfolio.get('contracts');

        dispatch(savePortfolioRequest());
        return APIPost(
            dispatch,
            apiURLBuilder.getURL('brokerCustomWalletCreate'),
            requestData
        )
            .then(
                (response) =>  {
                    let message = '';
                    if (requestData.query.portfolioAccountId == BROKER_CUSTOM_WALLET_CREATE_ACCOUNT_ID) {
                        message = formatText('brokerCustomWallet-createPortfolioSuccess');
                    } else {
                        message = formatText('brokerCustomWallet-saveChangesSuccess');
                        dispatch(portfolios.updatePortfolio(newName, newContracts, portfolioAccountId))
                    }
                    if (immBrokerCustomWalletEditablePortfolio.get('setDefaultOnCreate')) {
                        dispatch(setDefaultView(response.portfolioAccountId));
                    }
                    dispatch(notification.success({message}, {voice: message}));
                    callbacks.successCallback();
                }
            )
            .catch(
                (response) =>  {
                    dispatch(savePortfolioError(response.error));
                    dispatch(showValidationError());
                    let message = '';
                    if (requestData.query.portfolioAccountId == BROKER_CUSTOM_WALLET_CREATE_ACCOUNT_ID) {
                        message = formatText('brokerCustomWallet-createPortfolioError');
                        if (response.body.message === BROKER_CUSTOM_WALLET_MAX_ON_CREATE || response.message === BROKER_CUSTOM_WALLET_MAX_ON_CREATE) {
                            message = formatText('brokerCustomWallet-createPortfolioMaxError');
                        }
                    } else {
                        message = formatText('brokerCustomWallet-saveChangesError');
                    }
                    dispatch(notification.error({message}, {voice: message}));
                    callbacks.errorCallback();
                }
            );
    } else {
        dispatch(showValidationError());
    }
};

const getContractsListSuccess = (filteredResponse, enabledProducts) => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_CONTRACT_LIST_SUCCESS,
    payload: filteredResponse, enabledProducts
});

const getContractsListError = data => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_CONTRACT_LIST_ERROR,
    payload: data
});

const getContractsListRequest = () => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_CONTRACT_LIST_REQUEST
});

const getContractsList = () => (dispatch, getState) => {
    const requestData = {
        query: {
            idPortfolioAccount: null,
        },
    };

    dispatch(getContractsListRequest());
    return APIGet(
        dispatch,
        apiURLBuilder.getURL('brokerCustomWalletGetContracts'),
        requestData
    )
        .then(response => {
            const pgContracts = getState().brokerMyInvestments.get('contracts');
            const filteredResponse = filterPgContracts(pgContracts, response);
            APIGet(
                dispatch,
                apiURLBuilder.getURL('brokerFundsEnabledProducts'),
            ).then(response => {
                const {enabledProducts} = response
                dispatch(getContractsListSuccess(filteredResponse, enabledProducts))
            })
        })
        .catch(response => dispatch(getContractsListError(response.error)));
};

const enableAllPortfolioContractsByType = (portfolioType) => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_PORFOLIO_ENABLE_ALL_CONTRACTS_BY_TYPE,
    payload: portfolioType,
});

const disableAllPortfolioContractsByType = (portfolioType) => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_PORFOLIO_DISABLE_ALL_CONTRACTS_BY_TYPE,
    payload: portfolioType,
});

const setDefaultViewOnCreate = (setPortfolioDefaulChecked) => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_PORTFOLIO_SET_DEFAULT_ON_CREATE,
    payload: {
        setPortfolioDefaulChecked
     }
});

module.exports = {
    init,
    loadEditablePortfolio,
    loadEditablePortfolioById,
    inputNameChange,
    changeSwitchItemContract,
    savePortfolio,
    getContractsList,
    enableAllPortfolioContractsByType,
    disableAllPortfolioContractsByType,
    setDefaultView,
    setDefaultViewOnCreate
};
